import { css } from 'linaria';

export const dropzoneCapLeftCaption = css`
  flex-grow: 1;
  flex-shrink: 1;
  margin-left: var(--space-200) !important;
`;

export const dropzoneCapLeftContent = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
`;

export const inputContainer = css`
  display: none;
`;
